import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';   
import InfoIcon from '@mui/icons-material/Info';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import styled from '@emotion/styled';
import logo from '../assets/media/logo.svg';
import theme from '../themes/index.en';
import Navbar from './navbar';
import { useNavigate } from 'react-router-dom';
const { palette } = theme;

const GradientAppBar = styled(AppBar)`
  background: linear-gradient(to left, ${palette.primary.main}, ${palette.primary.dark});
  color: ${palette.common.white};
`;

const appVersion = process.env.REACT_APP_VERSION || '0';

const Header: React.FC<{ profile: any; menuData: any[] }> = ({ profile, menuData }) => {
  const navigate = useNavigate();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogout = async () => {
    navigate('/Logout');
    handleMenuClose();
  };
  
  return (
    <GradientAppBar position="static">
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/">
            <img src={logo} alt="Logo" style={{ height: '60px' }} />
          </Link>
        </Box>

        {/* Navbar */}
        {isMobile ? (
          <>
            <IconButton onClick={toggleDrawer} sx={{ color: palette.common.white }}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer}>
              <List>
                {menuData.map((section, index) => (
                  <ListItem key={index} onClick={toggleDrawer} component="button">
                      <ListItemText primary={section.section} />
                  </ListItem> 
                ))}
              </List>
            </Drawer>
          </>
        ) : (
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <Navbar menuData={menuData} />
          </Box>
        )}

        {/* Profile Icon */}
        <Box>
          <IconButton onClick={handleMenuOpen} sx={{ color: palette.common.white }}>
            <ManageAccountsIcon />
          </IconButton>
          <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}> 
            <MenuItem disabled>
              <AccountCircleIcon sx={{ marginRight: '8px' }} />
              {profile?.name || 'Guest'}
            </MenuItem>
            <MenuItem
              onClick={handleLogout}
              sx={{
                color: `${palette.text.primary}`,
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              <LogoutIcon sx={{ marginRight: '8px' }} /> Sign Out
            </MenuItem>
            <MenuItem  style={{borderTop: `1px solid ${theme.palette.primary.light}`}}> 
              <InfoIcon sx={{ marginRight: '8px' }} />
              Version {appVersion}
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </GradientAppBar>
  );
};

export default Header; 